class UserConsent {
    constructor(params) {
        this.params = params;
        this.init();
    }

    init() {
        this.showPopup();
    }

    showPopup() {
        const options = {
            title: BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_TITLE_COOKIES'),
            html: `
                <p class="mb-1">${BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_PREVIEW_TEXT')}</p>
                <button class="btn btn-link p-0" type="button" data-show-argeement>${BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_URL_CONFIRM')}</button>
            `,
            showCancelButton: true,
            confirmButtonText: BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_BTN_ACCEPT'),
            cancelButtonText: BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_BTN_REJECT'),
            confirmButtonClass: 'btn-primary',
            width: '413px',
            position: 'bottom-end',
            backdrop: false,
            willOpen: (popup) => {
                popup.querySelector('[data-show-argeement]').addEventListener('click', this.showFullTextPopup.bind(this));
            },
            customClass: {
                container: 'cookies-form',
                confirmButton: 'btn',
                cancelButton: 'btn btn-secondary',
                closeButton: 'd-none',
                actions: 'd-flex flex-column flex-sm-row align-items-start justify-content-start',
            },
        };

        SweetAlert.showPopup(options).then(async results => {
            const result = await results[0];

            if (result.isConfirmed) {
                this.accept();
            }
        });
    }

    showFullTextPopup() {
        const options = {
            title: this.params.title,
            html: this.params.text,
            showCancelButton: true,
            confirmButtonText: BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_BTN_ACCEPT'),
            cancelButtonText: BX.message('MAIN_USER_CONSENT_REQUEST_COOKIE_BTN_REJECT'),
            width: '640px',
            position: 'center',
            backdrop: true,
            focusConfirm: false,
            focusCancel: false,
            allowOutsideClick: false,
            customClass: {
                container: 'user-consent',
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-link',
                closeButton: 'd-none',
            },
        };

        SweetAlert.showPopup(options).then(async results => {
            const result = await results[0];

            if (result.isConfirmed) {
                this.accept();
            }
        });
    }

    accept() {
        const data = {
            'id': this.params.id,
            'sec': this.params.sec,
            'url': window.location.href,
            'action': 'saveConsent',
            'sessid': BX.bitrix_sessid()
        };
        const date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000)); // Set the cookie expiration date to 7 days

        BX.ajax({
            url: this.params.actionUrl,
            method: 'POST',
            data: data,
            timeout: 10,
            dataType: 'json',
            processData: true,
            onsuccess: () => {
                BX.setCookie('BITRIX_SM_SOTBIT_B2B_USERCONSENT_COOKIES', 'all', {path: '/', expires: date.toGMTString()});
            },
        });
    }
}